import { FC, ReactNode, Suspense } from 'react';
import Footer from '@/widgets/Footer/ui/Footer';
import Header from '@/widgets/Header/ui/Header';
import HeaderButtonsDefault from '@/widgets/Header/ui/HeaderButtons/HeaderButtonsDefault';
import { cva } from 'class-variance-authority';
import Container from '@/shared/ui/Container/ui/Container';

interface Props {
  children: ReactNode;
  headerSlot?: ReactNode;
  footerSlot?: ReactNode;
}

const defaultHeaderSlot = <Header buttonsSlot={<HeaderButtonsDefault />} />;
const defaultFooterSlot = <Footer />;

const Layout: FC<Props> = ({
  children,
  headerSlot = defaultHeaderSlot,
  footerSlot = defaultFooterSlot,
}) => {
  return (
    <div className={cvaRoot()}>
      <Suspense>{headerSlot}</Suspense>
      <Container className={cvaContainer()} size={'xl'}>
        {children}
      </Container>
      {footerSlot}
    </div>
  );
};

const cvaRoot = cva([
  'Layout-cvaRoot',
  'flex flex-col min-h-screen h-screen sm:h-auto',
]);

const cvaContainer = cva(['Layout-cvaContainer', 'flex flex-col flex-grow']);

export default Layout;
